import {Environment} from "../models/Environment";
import {Branding} from "../../types/Branding";

export function initGTM(containerID: string) {
    // gtmScript - Google Tag Manager (script)
    const gtmScript = document.createElement("script");
    gtmScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':`
        + `new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],`
        + `j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=`
        + `\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);`
        + `})(window,document,\'script\',\'dataLayer\',\'${containerID}\');`;

    // gtmScript2 - Google Tag Manager (noscript)
    const gtmScript2 = document.createElement("noscript");
    const elIframe = document.createElement("iframe");
    elIframe.setAttribute("src", `https://www.googletagmanager.com/ns.html?id=${containerID}`);
    elIframe.setAttribute("height", `0`);
    elIframe.setAttribute("width", `0`);
    elIframe.setAttribute("style", `display:none;visibility:hidden`);
    gtmScript2.appendChild(elIframe);

    document.documentElement.firstChild?.appendChild(gtmScript);
    document.body.insertBefore(gtmScript2, document.body.firstChild);
}

export function getCurrentEnvironment(): Environment {
    const host = window.location.host;
    if (host.indexOf("uat") !== -1) { return Environment.uat; }
    if (host.indexOf("localhost") !== -1) { return Environment.local; }
    return Environment.prod;
}

export function getGTMContainerId(branding: Branding) {
    switch (branding) {
        case Branding.OPEN_MARKETS:
            return "GTM-PWHJQC7";
        case Branding.BELLMONT:
            return "GTM-PWHJQC7";
        default:
            return "GTM-PWHJQC7";
    }
}
